import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

const Recaptcha = ({ innerRef, onChange, className = "mb-3 d-flex justify-content-center", ...props }) => {
  const siteKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY

  if (!siteKey) {
    return null
  }

  return (
    <div className={className}>
      <ReCAPTCHA
        ref={innerRef}
        sitekey={siteKey}
        onChange={onChange}
        size="invisible"
        {...props}
      />
    </div>
  )
}

export default Recaptcha
